import { useCostOverTime } from 'features/cost-report/hooks/useCostOverTime';
import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import { CostReportDataByPeriod } from 'features/cost-report/types/costOverTime';

import { CostReportTableData } from '../types';
import { mapCostReportChartDataToTableData } from '../_utils/mapCostReportToTableData';

type UseDailyCostSpendDetailsData = {
  isLoading: boolean;
  data: CostReportTableData[];
};

export const useDailyCostSpendDetailsData =
  (): UseDailyCostSpendDetailsData => {
    const { current, projectEndOfDayCost, storageCostGranularity } =
      useCostOverTime();
    const { timezone } = useCostReportContext();

    const data = mapCostReportChartDataToTableData({
      chartData: current.chartData as CostReportDataByPeriod[],
      timezone,
      storageCostGranularity,
      projectEndOfDayCost,
    });

    return {
      isLoading: current.isLoading,
      data,
    };
  };
